<router-outlet></router-outlet>
<div class="gtranslate_wrapper invisible"></div>
<app-loader></app-loader>

<app-toaster-container></app-toaster-container>